import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { _checkIfUserExist } from '../../../redux/actions';
import SignupForm from './SignupForm';
import LoginForm from './LoginForm';
import Button from '../../../components/Button';
var EmailPasswordAuth = function (props) {
    var navigate = useNavigate();
    var _a = useState(true), userIsNew = _a[0], setUserIsNew = _a[1];
    useEffect(function () {
        _checkIfUserExist(props.email).then(function (userExists) {
            return setUserIsNew(!userExists);
        });
    }, [props.email]);
    return (React.createElement(React.Fragment, null,
        userIsNew ? (React.createElement(SignupForm, { email: props.email })) : (React.createElement(LoginForm, { email: props.email })),
        React.createElement(Button, { label: '\u2190 Go back', style: 'tertiary', onClick: function () { return navigate('/'); }, id: 'back' })));
};
export default EmailPasswordAuth;
